<template>
    <transition name="fade">
        <div class="info-modal__wrapper" v-show="isOpen" @click.self="close" ref="wrapper">
            <transition name="scale">
                <div class="info-modal" v-show="isOpen">
                    <button class="info-modal__close is-cross" @click="close"></button>

                    <div class="info-modal__content frame-medium">
                        <h3 class="info-modal__headline main__headline">
                            {{ headline }}
                        </h3>

                        <div class="info-modal__text" v-html="text">
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'info-modal',
        props: {
            headline: String,
            text: String,
            isOpen: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss">

    @import '../scss/config';

    .info-modal {
        $close-size: rem(16);
        $icon-size: size(large);

        position: relative;
        width: 100%;
        background: color(background);
        margin: auto; // https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
        margin: size(medium);
        border-radius: size(smaller);
        box-shadow: 0 size(tiny) size(semi-large) color(background, $opacity: .5);
        padding: size(small);

        &__headline {
            margin: 0;
        }

        &__wrapper {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 100;
            width: 100%;
            height: 100vh;
            background: color(foreground, .8);
            overflow: scroll;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
            display: flex;
            align-items: center;
        }

        &__content {
            @include font-regular();
            font-size: size(font-small);

            footer {
                @include font-semibold();
                margin-top: 1em;
            }


            p {

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }

        &__close {
            position: absolute;
            top: size(medium);
            right: size(medium);

            @include cross-button((
                size: $close-size,
                color: color(foreground),
                roundness: size(line),
                thickness: .1,
            ));
        }

        // TODO: just a hot fix
        &::before {
            $size: $close-size * 2;
            $padding: rem(7);
            content: '';
            display: block;
            position: absolute;
            top: $padding;
            right: $padding;
            width: $size;
            height: $size;
            background: faint-color(background, 0.5);
        }
    }
</style>
